import * as VueRouter from 'vue-router';
import routes from '@/routes/routes';
import { useOidcStore } from 'vue3-oidc';
import { computed } from 'vue';
import authService from '@/services/auth/auth.service';
const { state, actions } = useOidcStore();
import { useStore } from '@/store';
import { LoaderActionTypes } from '@/store/loader/action-types';
import { GridActionTypes } from '@/store/grid/action-types';
import permissaoService from '@/services/auth/permissao.service';

const userManager = computed(() => state.value.userManager);

const router = VueRouter.createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: VueRouter.createWebHistory(),
  routes // short for `routes: routes`
});

const mesmaFamiliaDeRotas = (a: any, b: any): boolean => {
  if (!a?.name || !b?.name) return false;
  if (a.name === b.name) return true;

  const paiDeA = a.meta?.parentRouteName;
  const paiDeB = b.meta?.parentRouteName;

  return paiDeA === b.name || paiDeB === a.name || (!!paiDeA && paiDeA === paiDeB);
};

router.beforeEach(async (to, from, next) => {
  if (from.name && !mesmaFamiliaDeRotas(to, from)) {
    useStore().dispatch('grid/' + GridActionTypes.CLEAR_ALL_FILTERS);
  }

  const userRoles = await authService.getRolesFromToken();

  const user = await userManager.value?.getUser();

  if (to.name == '404') {
    if ((!user || user.expired) && !useStore().getters.getIsLegacy) {
      next({ name: 'lockscreen' });
      return;
    }
    next();
    return;
  }
  if (to.name == 'proxyLegado') {
    next();
    return;
  } else if (to.name == 'lockscreen') {
    next();
    return;
  } else if (to.name == 'oidc-callback') {
    next();
    return;
  } else if (to.name == 'denied' || to.name == 'accessdenied') {
    next();
    return;
  }

  if (user) {
    if (user.expires_in! > 0 && user.expires_in! <= 180) {
      try {
        const userSilent = await userManager.value?.signinSilent();
        userManager.value?.signinSilentCallback();
        actions.value.setUser(userSilent!);
      } catch {
        next({ name: 'lockscreen' });
        return;
      }
    } else if (user.expired == true) {
      try {
        useStore().dispatch(LoaderActionTypes.ACTION_SHOW);
        const userSilent = await userManager.value?.signinSilent();
        userManager.value?.signinSilentCallback();
        actions.value.setUser(userSilent!);
        useStore().dispatch(LoaderActionTypes.ACTION_HIDE);
      } catch {
        useStore().dispatch(LoaderActionTypes.ACTION_HIDE);
        next({ name: 'lockscreen' });
        return;
      }
    }
  } else if (useStore().getters.getIsLegacy) {
    next();
    return;
  } else {
    next({ name: 'lockscreen' });
    return;
  }

  if (
    !userRoles ||
    (Array.isArray(userRoles) && !userRoles.find((x: any) => x == import.meta.env.VITE_APP_CLIENT_ROLE)) ||
    (!Array.isArray(userRoles) && import.meta.env.VITE_APP_CLIENT_ROLE != userRoles)
  ) {
    next({ name: 'denied' });
    return;
  } else {
    const user = await userManager.value?.getUser();

    if (user && !user.expired) {
      //parte que valida se tem acesso a pagina

      const leafRouteMeta = to.matched[to.matched.length - 1]?.meta;
      if (permissaoService.temAcessoRota(leafRouteMeta)) {
        next();
        return;
      } else {
        next({ path: '/pagina-nao-encontrada' });
        return;
      }
    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
      //authentication is required. Trigger the sign in process, including the return URI
      //userManager.value?.signinRedirect();
      next();
    } else {
      //No auth required. We can navigate
      next();
    }
  }
});

router.afterEach(() => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      useStore().dispatch(LoaderActionTypes.ACTION_NAVIGATION_HIDE);
    });
  });
});

router.onError(() => {
  useStore().dispatch(LoaderActionTypes.ACTION_NAVIGATION_HIDE);
});

export default router;
